// import AuthWrapper from "@/layout/wrapper/AuthWrapper";
import React, { useState } from "react";
import styles from "../../styles/pages/login.module.scss";
import { Box, Button, Grid, OutlinedInput, Typography } from "@mui/material";
import Alert from "@mui/material/Alert";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import { useForm } from "react-hook-form";
// import { useforgotpassword } from "@/hooks/api/useUser";
// import useNotiStack from "@/hooks/useNotistack";
import { Link, useParams } from "react-router-dom";
import logo from "../../public/assets/images/logo.svg";
import useNotiStack from "../../hooks/useNotistack";
import { useforgotpassword } from "../../hooks/useUser";
import { useNavigate } from "react-router-dom";
const schema = yup.object().shape({
  email: yup
    .string()
    .required("This filed is required")
    .email("Please insert valid Email"),
});
const Index = () => {
  const {
    handleSubmit,
    control,
    register,
    setValue,
    reset,
    setError,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const { toastSuccess, toastError } = useNotiStack();
  const navigate = useNavigate();

  const { mutate, isSuccess } = useforgotpassword();
  const [step, setstep] = useState(false);
  const onSubmit = (data) => {
    mutate(data, {
      onSuccess: (res) => {
        console.warn(res, "sad1");

        if (
          res?.message ===
          "An OTP has been sent to your mail. Please check your email"
        ) {
          // toastSuccess(res?.message);

          navigate(`/Password-reset?email=${data?.email}`);
        } else {
          setError("email", {
            message:
              "Email not found in our records. Please double-check and try again.",
          });
        }
      },
    });
  };

  return (
    // <AuthWrapper>
    <Box className={styles.pageLogin}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={0}>
          <Grid item xs={12} md={6}>
            <Box className={styles.panelLeft}>
              <Link href="/">
                <img src={logo} alt="img" />
              </Link>
              <Box className={styles.authContent}>
                <Typography variant="h1">Forgot Your Password?</Typography>
                <Typography variant="body1">
                  Don't worry, it happens to the best of us. Enter the email
                  address you use to sign in to your account, and we'll send you
                  a password reset link.
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box className={`${styles.panelRight} ${styles.foraforgotPass}`}>
              <Typography variant="h2">
                <span>Almost there</span> Enter your email address below
              </Typography>
              <Box className={styles.formSec}>
                <Box className={styles.formGroup}>
                  <label>Email address</label>
                  <OutlinedInput
                    error={errors?.email?.message ? true : false}
                    //  label="Email address"
                    type="email"
                    placeholder={""}
                    {...register("email")}
                  />
                </Box>
                <Box className={styles.formGroup}>
                  <Button
                    className={`${styles.btnlogin} ${styles.btnRecover}`}
                    type="submit"
                  >
                    Send recover link
                  </Button>
                </Box>
                {errors.email && (
                  <Alert severity="error" className={styles.errorAlert}>
                    {errors.email.message}
                  </Alert>
                )}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </form>
    </Box>
    // </AuthWrapper>
  );
};

export default Index;
